import { NAV_MENU } from "./constants";
import { AccessEnum, NavMenuType } from "./types";

export function getSidebarItemsForRole(role?: number): NavMenuType[] {
  if (!role) return [];
  return NAV_MENU.filter(item => {
    if (!item.access) return true;
    return item.access.includes(role as AccessEnum);
  });
}

